import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as sagaAction from '../../sagas/saga_action';
import View from './view';

export default withRouter(connect(null, dispatch => ({
  handleLogin: async (values) => {
    dispatch({
      type: sagaAction.SAGA_POST_LOGIN,
      values,
    });
  },
}))(props => React.createElement(View, props)));
